import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { MsgPopupPipe } from './msg-popup.pipe';
import { DateCustomPipe } from './datetime-custom.pipe';
import { formatNamePipe } from './format-name.pipe';
import { SearchPipe } from './search-pipe';
import { CommaSepNamePipe } from './comma-sep-name.pip';
import { DomSanitize } from './dom-sanitize.pipe';
import { ParticipantCountPipe } from './participant-count.pipe';
import { SessionPipe } from './session.pipe';
import { SessionRolePipe } from './session-role.pipe';
import { UrlDetectPipe } from './urlDetect.pipe';

@NgModule({
  declarations: [
    MsgPopupPipe,
    DateCustomPipe,
    formatNamePipe,
    SearchPipe,
    CommaSepNamePipe,
    DomSanitize,
    ParticipantCountPipe,
    SessionPipe,
    SessionRolePipe,
    UrlDetectPipe
  ],
  imports: [CommonModule],
  exports: [
    MsgPopupPipe,
    DateCustomPipe,
    formatNamePipe,
    SearchPipe,
    CommaSepNamePipe,
    DomSanitize,
    ParticipantCountPipe,
    SessionPipe,
    SessionRolePipe,
    UrlDetectPipe
  ]
})

export class PipeModule { }